export const PROVIDER_BY_TOOL_PREFIX: Record<string, { provider: string; action: string }> = {
  // Gmail
  propose_send_email:  { provider: 'gmail',           action: 'send_email' },
  execute_send_email:  { provider: 'gmail',           action: 'send_email' },
  draft_email:         { provider: 'gmail',           action: 'draft_email' },
  // Google Calendar
  propose_create_event:{ provider: 'google_calendar', action: 'create_event' },
  execute_create_event:{ provider: 'google_calendar', action: 'create_event' },
  propose_update_event:{ provider: 'google_calendar', action: 'update_event' },
  execute_update_event:{ provider: 'google_calendar', action: 'update_event' },
  propose_cancel_event:{ provider: 'google_calendar', action: 'cancel_event' },
  execute_cancel_event:{ provider: 'google_calendar', action: 'cancel_event' },
  // Notion
  propose_create_page: { provider: 'notion',          action: 'create_page' },
  execute_create_page: { provider: 'notion',          action: 'create_page' },
  propose_update_page: { provider: 'notion',          action: 'update_page' },
  execute_update_page: { provider: 'notion',          action: 'update_page' },
  // Linear
  propose_create_issue:{ provider: 'linear',          action: 'create_issue' },
  execute_create_issue:{ provider: 'linear',          action: 'create_issue' },
  propose_update_issue:{ provider: 'linear',          action: 'update_issue' },
  execute_update_issue:{ provider: 'linear',          action: 'update_issue' },
};
